<template>
    <div class="modal fade" id="teamVolunteerProfileModal" ref="teamVolunteerProfileModal" tabindex="-1" role="dialog" aria-labelledby="teamVolunteerProfileModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="teamVolunteerProfileModalLabel">{{ $t('volunteer_profile.title') }}</h5>
                        </div>
                        <div class="col-12 mt-3">
                            <span class="detail-data canvassing-color-black">{{ person.name }}</span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-data canvassing-color-black">{{ person.email }}</span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-data canvassing-color-black">{{ person.user_area }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="!isOwner(person._id) && person.user_status != 'denied'" class="modal-footer modal-footer-canvassing-redish">
                    <span data-toggle="modal" data-target="#removeMemberCampaignModal" @click.prevent="dismissDetails" class="modal-footer-canvassing-red-button mt-3 mx-auto cursor-pointer">{{ $t('volunteer_profile.remove') }}</span>
                    <span class="note-text mx-auto mb-3">{{ $t('volunteer_profile.note') }}</span>
                </div>
                <div v-if="!isOwner(person._id) && person.user_status == 'denied'" class="modal-footer modal-footer-canvassing-redish">
                    <span class="mt-3 mx-auto cursor-pointer" @click.prevent="doAddVolunteer(person._id)">{{ $t('volunteer_profile.reactivate') }}</span>
                    <span class="note-text mx-auto mb-3">{{ $t('volunteer_profile.note_reactivate') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "TeamVolunteerProfileModal",
        props: ["person"],
        mixins: [HelperMixin],
        data() {
            return {
                
            }
        },
        created() {
            
        },
        computed: {
        
        },
        methods: {
            doAddVolunteer(personId) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                console.log(this.$route.params.campaign_id);
                console.log(personId);
                axios.post(
                    '/api/v1/campaign/' + this.$route.params.campaign_id + '/user/' + personId + '/accept',
                        {},
                        config
                ).then(this.consumedoAddVolunteer, this.errordoAddVolunteer);
            },

            consumedoAddVolunteer: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.dismissDetails();
                this.$router.go();
            },

            errordoAddVolunteer: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
               console.log(error);
            },

            dismissDetails() {
                $('#teamVolunteerProfileModal').modal('hide');
            },
        },
    };
</script>
